import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import LuggageOutlinedIcon from '@mui/icons-material/LuggageOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined';
import TodayIcon from '@mui/icons-material/Today';

const WorkflowListItems = [
  {
    text: 'CTP',
    icon: <HandshakeOutlinedIcon fontSize="medium" />,
    path: '/ctp-list',
    id: 18,
    testId: 'menu-item-ctp',
  },
  {
    text: 'PNR',
    icon: <ReportProblemOutlinedIcon />,
    path: '/pnr-list',
    id: 12,
    testId: 'menu-item-pnr',
  },
  {
    text: 'RIP',
    icon: <RequestQuoteOutlinedIcon />,
    path: '/rip-list',
    id: 14,
    testId: 'menu-item-rip',
  },
  {
    text: 'TAR',
    icon: <FlightTakeoffOutlinedIcon fontSize="medium" />,
    path: '/tar-imcs-list',
    id: 23,
    testId: 'menu-item-tar-imcs',
  },
  {
    text: 'Trip Report',
    icon: <LuggageOutlinedIcon fontSize="medium" />,
    path: '/tr-list',
    // path: '/trip-reports',
    id: 22,
    testId: 'menu-item-trip-report',
  },
];

export const mainListItems = [
  {
    text: 'Approvals',
    icon: <ChecklistIcon fontSize="medium" />,
    path: '/approvalQueue',
    id: 2,
  },
  {
    text: 'Schedule',
    icon: <TodayIcon fontSize="medium" />,
    path: '/master-schedule',
    id: 5,
  },
  { text: 'Financials', icon: <AttachMoneyIcon />, path: '/financials', id: 4 },
  { text: 'Projects', icon: <WorkOutlineIcon />, path: '/projects', id: 1 },
  {
    text: 'Deliverables',
    icon: <Inventory2OutlinedIcon fontSize="medium" />,
    path: '/deliverables',
    id: 3,
  },
  {
    text: 'Library',
    icon: <FolderOutlinedIcon fontSize="medium" />,
    path: '/library',
    id: 6,
  },
  {
    text: 'Forms',
    icon: <DynamicFormOutlinedIcon fontSize="medium" />,
    path: '/workflow',
    id: 7,
    children: WorkflowListItems,
    defaultOpen: true,
  },
];

// D.4: Admin navigation moved from the left drawer to the top-right header
// dropdown (see MenuTop.jsx). secondaryListItems is kept as an empty export
// for backwards compat with MenuContent/MenuIconOnly which still import and
// map over it — those callers now short-circuit because the array is empty.
export const secondaryListItems = [];

// Default export preserved for any callers that import the default shape.
export default {
  mainListItems,
  secondaryListItems,
};
